import {WorkspaceRoleForClient} from "./workspace-roles";

/*export class WorkspaceRolesMapper {

  public static map(user: any): WorkspaceRoles {
    const workspaceRoles: WorkspaceRoles = new WorkspaceRoles();
    workspaceRoles.workspaceRoles = WorkspaceRoleForClientMapper.map(user.workspace_roles.roles, user.workspace_roles.workspace);
    return workspaceRoles;
  }

}*/


export class WorkspaceRoleForClientMapper {

  public static map(userRole: any): WorkspaceRoleForClient {
    const clientWorkspace: WorkspaceRoleForClient = new WorkspaceRoleForClient();
    clientWorkspace.roleId = userRole.id;
    clientWorkspace.roleSlug = userRole.slug;
    clientWorkspace.displayName = userRole.display_name.trim().toLowerCase();
    return clientWorkspace;
  }

}
